import React, { useState } from 'react';
import axios from 'axios';
import './SignupForm.css';

// Full text of your Privacy Policy
const privacyPolicy = (
  <div>
    <h3>Privacy Policy</h3>
    <p>
      Admissions Express values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website or use our consultancy services.
    </p>
    <ol>
      <li>
        <strong>Information We Collect</strong>
        <ul>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Passport/ID details</li>
          <li>Educational documents</li>
          <li>Visa-related documents (I-20, DS-160, etc.)</li>
          <li>Payment details</li>
          <li>Other information you voluntarily provide</li>
        </ul>
      </li>
      <li>
        <strong>How We Use Your Information</strong>
        <ul>
          <li>Deliver consultancy services</li>
          <li>Process I-20 and DS-160 applications</li>
          <li>Assist with university admissions</li>
          <li>Communicate via email/phone/WhatsApp</li>
          <li>Manage billing and payments</li>
          <li>Improve services</li>
          <li>Meet legal requirements</li>
        </ul>
      </li>
      <li>
        <strong>Data Sharing</strong>
        <p>We never sell your personal data. We only share it:</p>
        <ul>
          <li>With partner universities (with consent)</li>
          <li>With immigration/legal bodies (if authorized or required)</li>
          <li>With secure third-party service providers</li>
          <li>When required by law</li>
        </ul>
      </li>
      <li>
        <strong>Data Security</strong>
        <p>No system is 100% foolproof, but we follow best-practice digital security.</p>
      </li>
      <li>
        <strong>Your Rights</strong>
        <ul>
          <li>Access your data</li>
          <li>Update or correct your data</li>
          <li>Request deletion (subject to legal/contractual limits)</li>
        </ul>
        <p>Contact: info@admissionsexpress.com</p>
      </li>
      <li>
        <strong>Cookies</strong>
        <p>Our site uses cookies to improve experience; you can disable them in browser settings.</p>
      </li>
      <li>
        <strong>Policy Updates</strong>
        <p>We may revise this policy—please revisit for changes.</p>
      </li>
      <li>
        <strong>Contact Us</strong>
        <p>📧 info@admissionsexpress.com<br/>🌐 www.admissionsexpress.com</p>
      </li>
    </ol>
  </div>
);

// Full text of your Terms & Conditions
const termsAndConditions = (
  <div>
    <h3>Terms &amp; Conditions</h3>
    <ol>
      <li>
        <strong>Overview</strong>
        <p>By using Admissions Express, you agree to these terms.</p>
      </li>
      <li>
        <strong>Services</strong>
        <ul>
          <li>Consultancy for studying abroad (USA focus)</li>
          <li>I-20 & DS-160 guidance</li>
          <li>Visa documentation assistance</li>
          <li>Accommodation help</li>
          <li>Pre-/post-arrival support</li>
        </ul>
      </li>
      <li>
        <strong>Payment Policy</strong>
        <ul>
          <li>All services prepaid unless agreed otherwise</li>
          <li>Secure online gateways</li>
          <li>No refunds once service delivered</li>
          <li>Visa refusal isn’t refundable</li>
        </ul>
      </li>
      <li>
        <strong>Client Responsibilities</strong>
        <ul>
          <li>Provide accurate info</li>
          <li>Cooperate during process</li>
          <li>Understand decisions are external</li>
        </ul>
      </li>
      <li>
        <strong>Intellectual Property</strong>
        <p>All materials are our IP; do not copy or redistribute.</p>
      </li>
      <li>
        <strong>Liability Limits</strong>
        <p>We aren’t liable for visa refusals, rejections, delays, or policy changes.</p>
      </li>
      <li>
        <strong>Termination</strong>
        <p>We may stop services if terms are breached, team abused, or payment fails.</p>
      </li>
      <li>
        <strong>Contact</strong>
        <p>📧 info@admissionsexpress.com<br/>🌐 www.admissionsexpress.com</p>
      </li>
    </ol>
  </div>
);

const SignupForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    contact: '',
    email: '',
    password: '',
    confirmPassword: '',
    country: '',
  educationLevel: '',
  referralSource: '',
referralOther: '', // when user selects "Other"
  });
  const [error, setError] = useState('');
  const [pwMismatch, setPwMismatch] = useState(false);
  const [loading, setLoading] = useState(false);

  // Email-verification modal state
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationStatus, setVerificationStatus] = useState('');
  const [emailForVerification, setEmailForVerification] = useState('');

  // Policy modal state
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [policyType, setPolicyType] = useState(''); // 'terms' or 'privacy'

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(f => ({ ...f, [name]: value }));
    if (name === 'password' || name === 'confirmPassword') {
      setPwMismatch(
        name === 'password'
          ? value !== formData.confirmPassword
          : formData.password !== value
      );
    }
  };

  const openPolicyModal = type => e => {
    e.preventDefault();
    setPolicyType(type);
    setShowPolicyModal(true);
  };
  const closePolicyModal = () => setShowPolicyModal(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (pwMismatch) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
const { data } = await axios.post(`${apiUrl}/users/signup`, {
  firstName: formData.firstName,
  lastName: formData.lastName,
  contact: formData.contact,
  email: formData.email,
  password: formData.password,
  country: formData.country,
  educationLevel: formData.educationLevel,
  referralSource: formData.referralSource, 
  referralOther: formData.referralOther || "", 

});
if (data.message?.includes("Admin user created")) {
  localStorage.setItem("authToken", data.token || "user-autologin");
  localStorage.setItem(
    "user",
    JSON.stringify({
      email: formData.email,
      name: `${formData.firstName} ${formData.lastName}`,
      role: "user",          
      isVerified: true,      
    })
  );

  window.location.href = "/dashboard";
  return;
}




      if (data.message !== 'Verification code sent. Please check your email.') {
        throw new Error('Signup failed.');
      }
      setEmailForVerification(formData.email);
      setShowVerificationModal(true);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Signup failed');
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
await axios.post(`${apiUrl}/users/verify-email/confirm`, {
        email: emailForVerification,
        code:  verificationCode,
      });
const loginRes = await axios.post(`${apiUrl}/users/signin`, {
        email:    emailForVerification,
        password: formData.password,
      });
      const { token, user } = loginRes.data;
      localStorage.setItem('authToken', token);
      localStorage.setItem('user', JSON.stringify(user));
      setVerificationStatus('success');
      setTimeout(() => (window.location.href = '/dashboard'), 1500);
    } catch {
      setVerificationStatus('error');
    }
  };

  return (
    <section className="signup-section">
      <div className="signup-container">
        <div className="signup-content">

      

          {/* Signup Form Pane */}
          <section className="form-panel">
            <h2>Create Your Account</h2>
            <form className="signup-form" onSubmit={handleSubmit}>

              {/* First + Last */}
              <div className="form-group two-col">
                <div>
                  <label htmlFor="firstName">First Name</label>
                  <input
                    id="firstName"
                    name="firstName"
                    type="text"
                    placeholder="First Name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    id="lastName"
                    name="lastName"
                    type="text"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Passwords */}
              <div className="form-group two-col">
                <div>
                  <label htmlFor="password">Password</label>
                  <input
                    id="password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    id="confirmPassword"
                    name="confirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              {pwMismatch && (
                <div className="error-message small">
                  Passwords must match.
                </div>
              )}

              {/* Contact */}
              <div className="form-group">
                <label htmlFor="contact">Contact Number</label>
                <input
                  id="contact"
                  name="contact"
                  type="tel"
                  placeholder="+1 (555) 123-4567"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>
              {/* Country */}
<div className="form-group">
  <label htmlFor="country">Country</label>
  <select
    id="country"
    name="country"
    value={formData.country}
    onChange={handleChange}
    required
  >
    <option value="">Select your country</option>
    {[
      "United States", "Canada", "United Kingdom", "Australia", "India",
      "Pakistan", "Bangladesh", "China", "Germany", "France", "Nigeria",
      "South Africa", "Brazil", "Mexico", "Japan", "Philippines",
      "Saudi Arabia", "United Arab Emirates", "Nepal", "Sri Lanka",
      "Vietnam", "Indonesia", "Malaysia", "Kenya", "Ghana", "Turkey",
      "Italy", "Spain", "Russia", "Other"
    ].map((country, idx) => (
      <option key={idx} value={country}>{country}</option>
    ))}
  </select>
</div>

{/* Education Level */}
<div className="form-group">
  <label htmlFor="educationLevel">Education Level</label>
  <input
    id="educationLevel"
    name="educationLevel"
    type="text"
    placeholder="e.g. Bachelor's, Master's, High School"
    value={formData.educationLevel}
    onChange={handleChange}
    required
  />
</div>

{/* Referral Source */}
<div className="form-group">
  <label htmlFor="referralSource">Where did you hear about us?</label>
  <select
    id="referralSource"
    name="referralSource"
    value={formData.referralSource}
    onChange={handleChange}
    required
  >
    <option value="">Select an option</option>
    <option value="Instagram">Instagram</option>
    <option value="Facebook">Facebook</option>
    <option value="Google">Google</option>
    <option value="YouTube">YouTube</option>
    <option value="Friend or Family">Friend / Family</option>
    <option value="Other">Other</option>
  </select>

  {/* Conditionally show text box for "Other" */}
  {formData.referralSource === "Other" && (
    <input
      type="text"
      name="referralOther"
      placeholder="Please specify"
      value={formData.referralOther}
      onChange={handleChange}
      style={{ marginTop: "10px" }}
      required
    />
  )}
</div>


              {/* Agreement Text */}
              <p className="agreement-text">
                By signing up, you agree to our{' '}
                <a href="#" onClick={openPolicyModal('terms')}>
                  Terms &amp; Conditions
                </a>{' '}
                and{' '}
                <a href="#" onClick={openPolicyModal('privacy')}>
                  Privacy Policy
                </a>.
              </p>

              {error && <div className="error-message">{error}</div>}

              <button
                className="signup-btn"
                type="submit"
                disabled={loading || pwMismatch}
              >
                {loading ? 'Signing Up…' : 'Create My Free Account'}
              </button>
            </form>
          </section>
        </div>

        {/* Verification Modal */}
        {showVerificationModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h3>Email Verification</h3>
              <p>
                Enter the 6-digit code we sent to{' '}
                <strong>{emailForVerification}</strong>:
              </p>
              <input
                type="text"
                maxLength={6}
                placeholder="123456"
                value={verificationCode}
                onChange={e => setVerificationCode(e.target.value)}
                required
              />
              <button className="verify-btn" onClick={handleVerifyCode}>
                Verify &amp; Continue
              </button>
              {verificationStatus === 'success' && (
                <p className="success-text">Verified! Redirecting…</p>
              )}
              {verificationStatus === 'error' && (
                <p className="error-text">Invalid or expired code.</p>
              )}
            </div>
          </div>
        )}

        {/* Policy Modal */}
        {showPolicyModal && (
          <div className="modal-overlay">
            <div className="modal-content policy-modal">
              <button
                className="modal-close-btn"
                onClick={closePolicyModal}
                aria-label="Close"
              >
                &times;
              </button>
              <div className="policy-text">
                {policyType === 'privacy'
                  ? privacyPolicy
                  : termsAndConditions}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
export default SignupForm;
